import { Constants, MQ } from "./helpers/constants.js";

import { Navigation } from "./Components/Navigation.js";
import { Modals } from "./Components/Modals.js";
import { ISI } from "./Components/ISI.js";
import { Forms } from "./Components/Forms.js";
import { MetastaticToggle } from "./Components/MetastaticToggle.js";
import { Collapsible } from "./Components/Collapsible.js";
import { OnThisPage } from "./Components/OnThisPage.js";
import { CardToggle } from "./Components/CardToggle.js";

//SCROLLER CLASS CHANGE AT BOTTOM OF PAGE

$(window).on("scroll", function () {
    $("body").innerHeight();

    const pos = Math.ceil(window.innerHeight + window.scrollY);

    if (pos >= document.body.offsetHeight) {
        $(".scroller").addClass("bottom");
    } else if (pos < document.body.offsetHeight) {
        $(".scroller").removeClass("bottom");
    }
});

const addScript = function (path, callback) {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.addEventListener("load", callback);
    script.src = path;
    document.querySelector("head").appendChild(script);
};

window.addEventListener("load", function () {
    //append other scripts dynamically
    addScript("/js/iScroll.js", function () {
        Navigation.init();
        ISI.init();
        Collapsible.init();
        OnThisPage.init();
        CardToggle.init();

        // NOT IN USE
        //Forms.init();

        if (document.querySelectorAll(".modal").length > 0) {
            Modals.init();
        }

        if (
            document.querySelectorAll(".metastatic-toggle-container").length > 0
        ) {
            MetastaticToggle.init();
        }

        // NOT IN USE
        // if(document.querySelector('.navigation .homeModal') !== null) {
        //     HomeModal.init();
        // }

        if (Constants.isIE) {
            document.createElement("picture");
        }

        // Anchor on load animation
        if (Navigation.vars.anchorTarget) {
            console.log(
                "Navigation.vars.anchorTarget",
                Navigation.vars.anchorTarget
            );
            Navigation.events.goToAnchorOnLoad();
        }
    });

    // 2025 ISI
    $("#isi .button").on("click", function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        ISI.events.expand();
    });

    $(".isi-trigger").on("click", function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        if (MQ.LG.matches) {
            const isExpanded =
                $("#isi").hasClass("expand") ||
                $("#isi .outer").hasClass("expand");

            if (!isExpanded) {
                ISI.events.expand();
            } else {
                ISI.syncDesktopScrollLock();
            }

            return;
        }

        ISI.events.isiLink(e);
    });

    // Homepage animation
    const layers = document.querySelectorAll(".layer");
    if (layers.length > 0) {
        let currentIndex = 0;

        function cycleLayers() {
            layers.forEach((layer) => layer.classList.remove("active"));
            layers[currentIndex].classList.add("active");
            currentIndex = (currentIndex + 1) % layers.length;
        }

        let slideDuration = 3500;
        cycleLayers(); // Initialize
        setInterval(cycleLayers, slideDuration); // Cycle every 3.5 seconds
    }
});

//IE detection needs to occur ASAP
try {
    const ua = navigator.userAgent;
    Constants.isIE = ua.indexOf("Trident") > -1;
} catch (err) {
    Constants.isIE = false;
}

// For anchor scroll on load
if (window.location.hash) {
    Navigation.vars.anchorTarget = window.location.hash;
    Navigation.vars.anchorTarget = Navigation.vars.anchorTarget.replace(
        "#",
        ""
    );

    if (Navigation.vars.anchorTarget != "isi") {
        if (history.replaceState) {
            history.replaceState(
                "",
                document.title,
                window.location.pathname + window.location.search
            );
        } else {
            window.location.hash = "";
        }
    }
}


// add OS and browser class to html element
(function() {
    var html = document.documentElement;
    var userAgent = navigator.userAgent.toLowerCase();
    console.log(userAgent);

    // Function to add a class to the html
    function addClass(name) {
        if (html.classList) {
            html.classList.add(name);
        } else {
            html.className += ' ' + name;
        }
    }

    // Detect OS
    if (userAgent.indexOf('win') !== -1) {
        addClass('windows');
    } else if (userAgent.indexOf('macintosh') !== -1) {
        addClass('mac');
    } else if (userAgent.indexOf('linux') !== -1) {
        addClass('linux');
    } else if (userAgent.indexOf('android') !== -1) {
        addClass('android');
    } else if (userAgent.indexOf('iphone') !== -1 || userAgent.indexOf('ipad') !== -1) {
        addClass('ios');
    }

    // Detect browser
    if (userAgent.indexOf('chrome') !== -1 && userAgent.indexOf('edg') === -1) {
        addClass('chrome');
    } else if (userAgent.indexOf('safari') !== -1 && userAgent.indexOf('chrome') === -1) {
        addClass('safari');
    } else if (userAgent.indexOf('firefox') !== -1) {
        addClass('firefox');
    } else if (userAgent.indexOf('msie') !== -1 || userAgent.indexOf('trident') !== -1) {
        addClass('ie');
    } else if (userAgent.indexOf('edg') !== -1) {
        addClass('edge');
    }

})();